export default function StepProgressbarV3({ step }: { step: number }) {
  const colorCircleInactive = "#EEEEEE";
  const colorActive = "#C1D5FE";
  const colorLineInactive = "#C6C6C6";

  return (
    <div>
      <svg
        width="536"
        height="38"
        viewBox="0 0 536 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full"
      >
        <rect width="38" height="38" rx="19" fill={colorActive} />
        <path
          d="M20.6779 25H18.6619V17.88C18.6619 17.6453 18.6619 17.4053 18.6619 17.16C18.6725 16.9147 18.6832 16.6693 18.6939 16.424C18.7045 16.168 18.7152 15.9333 18.7259 15.72C18.6192 15.8267 18.4859 15.9547 18.3259 16.104C18.1659 16.2427 18.0005 16.3867 17.8299 16.536L16.5499 17.56L15.5419 16.312L18.9979 13.576H20.6779V25Z"
          fill="#222222"
        />
        <g fill={step > 1 ? colorActive : colorLineInactive}>
          <circle cx="53" cy="19" r="3" />
          <circle cx="67" cy="19" r="3" />
          <circle cx="81" cy="19" r="3" />
          <circle cx="95" cy="19" r="3" />
          <circle cx="109" cy="19" r="3" />
          <circle cx="123" cy="19" r="3" />
          <circle cx="137" cy="19" r="3" />
          <circle cx="151" cy="19" r="3" />
        </g>
        <rect
          x="166"
          width="38"
          height="38"
          rx="19"
          fill={step > 1 ? colorActive : colorCircleInactive}
        />
        <path
          d="M188.934 25H181.11V23.512L184.022 20.568C184.598 19.9813 185.067 19.48 185.43 19.064C185.803 18.6373 186.075 18.2427 186.246 17.88C186.427 17.5173 186.518 17.1227 186.518 16.696C186.518 16.1733 186.369 15.784 186.07 15.528C185.771 15.2613 185.377 15.128 184.886 15.128C184.406 15.128 183.958 15.2293 183.542 15.432C183.126 15.624 182.694 15.9013 182.246 16.264L181.142 14.936C181.462 14.6587 181.803 14.408 182.166 14.184C182.529 13.9493 182.939 13.7627 183.398 13.624C183.857 13.4853 184.39 13.416 184.998 13.416C185.734 13.416 186.363 13.5493 186.886 13.816C187.419 14.072 187.83 14.4293 188.118 14.888C188.406 15.3467 188.55 15.88 188.55 16.488C188.55 16.9573 188.481 17.3947 188.342 17.8C188.203 18.1947 188.001 18.584 187.734 18.968C187.467 19.352 187.142 19.7413 186.758 20.136C186.374 20.5307 185.942 20.9573 185.462 21.416L183.654 23.16V23.256H188.934V25Z"
          fill="#222222"
        />
        <g fill={step > 2 ? colorActive : colorLineInactive}>
          <circle cx="219" cy="19" r="3" />
          <circle cx="233" cy="19" r="3" />
          <circle cx="247" cy="19" r="3" />
          <circle cx="261" cy="19" r="3" />
          <circle cx="275" cy="19" r="3" />
          <circle cx="289" cy="19" r="3" />
          <circle cx="303" cy="19" r="3" />
          <circle cx="317" cy="19" r="3" />
        </g>
        <rect
          x="332"
          width="38"
          height="38"
          rx="19"
          fill={step > 2 ? colorActive : colorCircleInactive}
        />
        <path
          d="M354.486 16.184C354.486 16.696 354.379 17.144 354.166 17.528C353.963 17.912 353.681 18.2267 353.318 18.472C352.955 18.7067 352.534 18.8773 352.054 18.984V19.032C352.971 19.1387 353.665 19.4213 354.134 19.88C354.603 20.3387 354.838 20.9467 354.838 21.704C354.838 22.3653 354.678 22.9573 354.358 23.48C354.038 24.0027 353.542 24.4133 352.87 24.712C352.209 25.0107 351.355 25.16 350.31 25.16C349.691 25.16 349.115 25.1067 348.582 25C348.049 24.904 347.547 24.7493 347.078 24.536V22.76C347.558 23.0053 348.07 23.192 348.614 23.32C349.158 23.448 349.67 23.512 350.15 23.512C351.078 23.512 351.734 23.3467 352.118 23.016C352.502 22.6747 352.694 22.2053 352.694 21.608C352.694 21.224 352.598 20.9093 352.406 20.664C352.214 20.4187 351.899 20.2373 351.462 20.12C351.035 19.992 350.475 19.928 349.782 19.928H348.822V18.312H349.798C350.47 18.312 350.998 18.2373 351.382 18.088C351.777 17.9387 352.054 17.7307 352.214 17.464C352.385 17.1973 352.47 16.888 352.47 16.536C352.47 16.0773 352.321 15.72 352.022 15.464C351.723 15.208 351.275 15.08 350.678 15.08C350.294 15.08 349.947 15.1227 349.638 15.208C349.329 15.2933 349.046 15.4053 348.79 15.544C348.534 15.672 348.294 15.8107 348.07 15.96L347.11 14.568C347.398 14.3547 347.723 14.1627 348.086 13.992C348.449 13.8107 348.854 13.672 349.302 13.576C349.75 13.4693 350.241 13.416 350.774 13.416C351.958 13.416 352.87 13.6667 353.51 14.168C354.161 14.6587 354.486 15.3307 354.486 16.184Z"
          fill="#222222"
        />
      </svg>
    </div>
  );
}
